'use client';

import { type HTMLAttributes, type ReactNode } from 'react';

import { clsx } from '@/libs';

type CardRootProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
};

export const CardRoot = ({ children, className, ...props }: CardRootProps) => {
  return (
    <div
      className={clsx(
        'rounded-lg shadow-md p-4 bg-white border border-gray-200',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};
